import CustomButton from "components/button/custom_button";
import Card from "components/card";

function Notification() {
  return (
    <Card extra={"w-full h-full p-3"}>
      <div className="relative mb-3 flex items-center justify-between pt-1">
        <h4 className="text-xl font-bold text-navy-700 dark:text-white">
          Мэдэгдэл
        </h4>
      </div>
      <div className="flex flex-col"></div>
    </Card>
  );
}

export default Notification;
